import _store from "store2";
import {checkUserIsAdmin, getPositionByLogin, logout} from "../../api/index";
import {V2UserInfoForToken} from "@/api/v2UserInfoForToken";
import {ElMessage} from "element-plus";
import {useWebSocket} from "../../Hooks";
import router from '@/router'
import store from "@/store";
import {getCompanyCurrentInfo} from "@/api/usercenter";
import sessionStore from "@/utils/sessionStore";
import {Storage} from "@/utils/storage";
import {UserTable} from "@/views/Marketing/db_user";
import {CustomerTable} from "@/views/Marketing/db_customer";
import {
    clearBrowserStorageWithBackup,
    getDefaultPreservedLocalStorageKeys,
    resetWindowLevelAccountCache,
    restoreBrowserStorageBackup
} from "@/utils/accountCache";
import {resetRequestRuntimeCache} from "@/utils/request";
import {ACCOUNTS_STORAGE_KEY, LOGIN_ROUTE_DRAFT_KEY, markAccountSessionLoggedOut} from "@/utils/loginAccountMemory";

const ADMIN_CACHE_TTL_MS = 5 * 60 * 1000;
const adminPendingByTeamId = new Map();

function normalizeTeamId(raw) {
    if (raw == null) return '';
    if (Array.isArray(raw)) {
        const first = raw[0];
        if (first && typeof first === 'object') return String(first.id ?? '');
        return String(first ?? '');
    }
    if (typeof raw === 'object') return String(raw.id ?? '');
    return String(raw);
}

function normalizeUserId(raw) {
    if (raw == null) return '';
    const s = String(raw).trim();
    return s;
}

function getAdminCacheKey(userId, teamId) {
    const uid = normalizeUserId(userId);
    const tid = normalizeTeamId(teamId);
    if (!uid || !tid) return '';
    return `userIsAdmin:${uid}:${tid}`;
}

function readCachedAdmin(userId, teamId) {
    const cacheKey = getAdminCacheKey(userId, teamId);
    if (!cacheKey) return null;
    const cached = sessionStore.get(cacheKey);
    if (!cached || typeof cached !== 'object') return null;
    const value = cached.value;
    const ts = cached.ts;
    if (typeof value !== 'number' || typeof ts !== 'number') return null;
    if (Date.now() - ts > ADMIN_CACHE_TTL_MS) return null;
    return value;
}

function writeCachedAdmin(userId, teamId, value) {
    const cacheKey = getAdminCacheKey(userId, teamId);
    if (!cacheKey) return;
    sessionStore.set(cacheKey, {value, ts: Date.now()});
}

function resetRootModuleRuntimeState(rootState) {
    const {email, system, cloud, countshow, message, customer, sidebar, AI} = rootState || {};

    if (email) {
        email.teamID = "";
        email.teamList = [];
        email.teamListLoaded = false;
        email.shouldShowSideBar = false;
        email.isClose = false;
        email.EmailUnReadNum = 0;
        email.RequestToAuditSum = 0;
        email.auditMailNum = 0;
        email.nBarUnreadMailNum = 0;
        email.mailFollowNum = 0;
        email.customerFollowNum = 0;
        email.defaultMailbox = "";
        email.myUserEmailList = [];
        email.curTeamMyMemberType = 0;
        email.selectMember_Admin = "";
        email.selectTeamMembers_Admin = [];
        email.selectMemberEmail_Admin = "";
        email.selectMembersEmailList_Admin = [];
    }

    if (system) {
        if (Array.isArray(system.tabList) && system.tabList[1]) {
            Object.assign(system.tabList[1], {
                cacheName: "",
                query: {},
                params: {},
            });
        }
        system.friendList = [];
        system.groupList = [];
        system.frientRequestList = [];
        system.frientRequestUnreadCount = 0;
        system.conversationList = [];
        system.curConversationObj = {};
        system.noticeSum = 0;
        system.apiCount = 0;
        system.isChatBoxVisibe = false;
        if (Array.isArray(system.myMessageList)) {
            system.myMessageList = system.myMessageList.map(item => ({...item, count: 0}));
        }
    }

    if (cloud) {
        cloud.downloadStatus = "done";
        cloud.fileList = [];
        cloud.dirFileList = [];
        cloud.moveFileList = [];
        cloud.sharedUserList = [];
        cloud.shareTargetUser = {};
        cloud.targetTabData = {};
        cloud.spaceSize = {};
        cloud.userDataInformation = {};
        cloud.echartsData = [];
        cloud.total = 0;
        cloud.pages = 1;
        cloud.isCurrent = false;
        cloud.isFirstPageLoaded = false;
    }

    if (countshow) {
        countshow.myEmailList = [];
        countshow.allEmailList = [];
        countshow.getEmailListFlag = 0;
        countshow.sidebarTargetNumber = 0;
        countshow.sidbarNumbers = 0;
        countshow.teamSumDataLoading = false;
        countshow.teamSumDataLoadedTeamId = '';
    }

    if (message) {
        message.allDataList = [];
        message.allDataTotal = 0;
        message.allDataIsLoading = false;
        message.newData = [];
        message.allNewData = 0;
        message.allNewDataIsLoading = false;
        message.emailData = [];
        message.currentMessage = {};
        message.announcementInfo = 0;
        message.notifyList = [];
    }

    if (customer) {
        customer.contactList = [];
        customer.contactMessage = {};
        customer.contactMessageTemp = {};
        customer.selectedRows = [];
        customer.globalSelectedRows = {};
        customer.multipleSelection = [];
        customer.isCounterElection = false;
    }

    if (sidebar) {
        sidebar.fileList = [];
        sidebar.targetFileList = [];
        sidebar.latestFileListRequestId = 0;
        sidebar.latestAllListRequestId = 0;
        if (sidebar.pageSetting) {
            sidebar.pageSetting.pageNo = 1;
            sidebar.pageSetting.pageSize = 20;
            sidebar.pageSetting.total = 0;
            sidebar.pageSetting.pages = 0;
        }
    }

    if (AI) {
        AI.chatContentArray = [];
        AI.chatContentArrayMail = [];
        AI.currentLastNewChat = {};
        AI.chatDetailList = [];
        AI.currentTargetChat = [];
        AI.currentTargetChatMail = [];
        AI.associateId = "";
        AI.associateIdMail = "";
        AI.chatDetailListParent = [];
        AI.chatDetailListParentMail = [];
        AI.currentPage = 1;
        AI.currentPageMail = 1;
        if (AI.chatDetailListSetting) {
            AI.chatDetailListSetting.pageNo = 1;
            AI.chatDetailListSetting.pageSize = 30;
            AI.chatDetailListSetting.total = 0;
        }
        if (AI.currentTargetSetting) {
            AI.currentTargetSetting.pageNo = 1;
            AI.currentTargetSetting.pageSize = 999999;
            AI.currentTargetSetting.total = 0;
        }
        if (AI.currentTargetSettingMail) {
            AI.currentTargetSettingMail.pageNo = 1;
            AI.currentTargetSettingMail.pageSize = 999999;
            AI.currentTargetSettingMail.total = 0;
        }
        if (AI.chatDetailListSettingParent) {
            AI.chatDetailListSettingParent.pageNo = 1;
            AI.chatDetailListSettingParent.pageSize = 1;
            AI.chatDetailListSettingParent.total = 0;
        }
        if (AI.chatDetailListSettingParentMail) {
            AI.chatDetailListSettingParentMail.pageNo = 1;
            AI.chatDetailListSettingParentMail.pageSize = 1;
            AI.chatDetailListSettingParentMail.total = 0;
        }
    }
}

const userInfo = {
    account: "", accountType: 1, //1=个人账号 2=企业主账号 3=企业子账号
    enterpriseID: 0, guid: "", iM_Sign: "", photoUrl: "", token: "", userID: 0, userName: "", isVip: 0, userType: 10, //10 普通 20管路员 99主账号
};

const UserInfoForGUID = {
    guid: "",
    zoneCode: "",
    userCode: "",
    token: "",
    userID: 0,
    accountType: 1, //1=个人账号 2=企业主账号 3=企业子账号
    enterpriseID: 0,
    account: "",
    userName: "",
    phoneCode: "",
    phone: "",
    identificationStatus: 0,
    photoUrl: "",
    sex: 0,
    country: "",
    address: "",
    language: "",
    emailAddress: "",
    iM_Sign: "",
    teamID: 0,
    isVip: 0,
    vipExpireDate: null,
};

const token = _store.get("token");
const loginStatus = !!token || false;
const UserEmailList = _store.get("UserEmailList") || [];
const user = {
    namespaced: true, state: {
        loginStatus,
        userInfo: _store.get("userInfo") || userInfo,
        UserInfoForGUID: _store.get("UserInfoForGUID") || UserInfoForGUID,
        token,
        UserEmailList,
        userIsAdmin: sessionStore.get('userIsAdmin') ?? 1, //是否是管理员
        mailWorkPosition: {},//工位信息
        // 企业公司主账号信息
        companyInformation: {},
        tableDataEdm: [],
    }, getters: {
        isVipAccount(state) {
            // 会员等级:(0:免费用户,1:铜级用户,2:银级用户,3:金级用户)
            return typeof state.userInfo?.isVip === 'number' && state.userInfo.isVip > 0;
        },
        isVipUser(state) {
            const expireRaw = state.userInfo?.vipExpireDate;
            const isForever = expireRaw === null || expireRaw === undefined || expireRaw === '';
            const expireTime = typeof expireRaw === 'string' ? new Date(expireRaw).getTime() : Number(expireRaw);
            const now = Date.now();

            console.log('VIP 过期时间:', expireTime);
            console.log('当前时间:', now);

            if (isForever) return state.userInfo?.isVip * 1 !== 0;
            if (Number.isNaN(expireTime)) return false;
            return expireTime > now;
        }, isEnterpriseChildUser(state) {
            return state.userInfo.accountType === 3;
        }, isEnterpriseMainUser(state) {
            return state.userInfo.accountType === 2;
        }, isNormalUser(state) {
            return state.userInfo.accountType === 1;
        }, //     超级管理员 superAdmin
        isSuperAdmin(state) {
            return state.userIsAdmin === 3
        }, //     管理员 admin
        isAdmin(state) {
            return state.userIsAdmin === 2
        }, //     普通用户
        isPublic(state) {
            return state.userIsAdmin === 1
        }
    }, mutations: {
        SetUserEmailList(state, list) {
            state.UserEmailList = list;
            _store("UserEmailList", list);
        }, setMailWorkPosition(state, payload) {
            state.mailWorkPosition = payload
        },
    }, actions: {
        async findTargetBuyType({dispatch}) {
            const raw = localStorage.getItem("selectTargetProduct");
            let selectTargetProduct;

            try {
                selectTargetProduct = JSON.parse(raw);
            } catch (e) {
                console.error("JSON 解析失败", e);
                return;
            }

            if (selectTargetProduct) {
                const {productSort} = selectTargetProduct;

                if (productSort && productSort >= 5) {
                    await dispatch("getUserInfoForGUID"); // user 模块内部调用
                } else if (productSort && productSort <= 4) {
                    await dispatch("cloud/queryByUserIdApis", null, {root: true}); // 跨模块调用
                }
            }

            console.log("selectTargetProduct", selectTargetProduct);
        }, UserLogin({state, commit}, userInfo) {
            Object.assign(state.userInfo, userInfo);
            state.token = userInfo.token;
            _store("userInfo", userInfo);
            _store("token", userInfo.token);
            // _store('imSign', userInfo.iM_Sign)
            _store("guid", userInfo.guid);
            _store("nBarUnreadMailNum", 0);
            commit("system/changeLanguage", userInfo.language, {root: true});
            state.loginStatus = true;
        }, async UserQuit({state, rootState, dispatch}, payload = {}) {
            const preserveLoginRouteDraft = payload?.preserveLoginRouteDraft === true;
            const skipLogoutRequest = payload?.skipLogoutRequest === true;
            try {
                if (!skipLogoutRequest) {
                    await logout({userId: state.userInfo?.id}, {
                        errorPop: false,
                        dedupe: false,
                        skipAuthExpiredHandler: true,
                    })
                }
                try {
                    const currentAccountId = String(state.userInfo?.id ?? state.userInfo?.userID ?? state.userInfo?.guid ?? '')
                    if (currentAccountId) {
                        markAccountSessionLoggedOut(currentAccountId)
                    }
                } catch (e) {
                }
                const {stopWS} = useWebSocket(state.userInfo.id);
                stopWS();
                window.socketTarget = null;
                state.token = "";
                state.UserEmailList = [];
                state.loginStatus = false;
                _store.remove("userInfo");
                _store.remove("UserInfoForGUID");
                Object.assign(state.userInfo, userInfo);
                Object.assign(state.UserInfoForGUID, UserInfoForGUID);
                _store.remove("token");
                _store.remove("imSign");
                _store.remove("guid");
                _store.remove("UserEmailList");
                _store("nBarUnreadMailNum", 0);
                // 过期退出
                localStorage.removeItem("currentTime");
                localStorage.removeItem("lastTime");
                resetRootModuleRuntimeState(rootState);
                dispatch("email/resetTeam", {}, {root: true});

                const storageBackup = clearBrowserStorageWithBackup({
                    preserveLocalKeys: [
                        ...getDefaultPreservedLocalStorageKeys(),
                        ACCOUNTS_STORAGE_KEY,
                    ],
                    preserveSessionKeys: preserveLoginRouteDraft ? [LOGIN_ROUTE_DRAFT_KEY] : [],
                });
                resetWindowLevelAccountCache();
                resetRequestRuntimeCache();
                // 清空数据表
                UserTable.clear()
                CustomerTable.clear()
                store.commit('email/setCurTeamID', '')

                restoreBrowserStorageBackup(storageBackup)
            } catch (e) {
                console.log(e, 'error')
            } finally {
                router.push('/login')
            }
        }, async getUserInfoForGUID({state, dispatch}) {
            const result = await V2UserInfoForToken();
            if (result.code !== 200) {
                dispatch("user/UserQuit")
                return
            }
            // 覆盖 userInfo 数据
            localStorage.setItem('userInfo', JSON.stringify(result.result))
            _store("userInfo", result.result)
            Storage.set("tinymce-default-font-family", result.result.userFront !== "" ? result.result.userFront : `"Microsoft YaHei", "Helvetica Neue", "PingFang SC", sans-serif`)
            state.userInfo = result.result
            const accountType = result.result.accountType;
            _store("UserInfoForGUID", accountType);
        }, // 判断当前用户是否是管理员
        async checkUserInfoIsAdmin({state}, payload) {
            let isUpdate = false
            if (payload) {
                isUpdate = payload.isUpdate
            }
            try {
                const teamId = normalizeTeamId(payload?.teamId);
                if (!teamId) return;
                const userId = normalizeUserId(state.userInfo?.id || state.userInfo?.userID);

                if (!isUpdate) {
                    const cached = readCachedAdmin(userId, teamId);
                    if (cached !== null) {
                        state.userIsAdmin = cached;
                        return cached;
                    }

                    const pending = adminPendingByTeamId.get(teamId);
                    if (pending) {
                        const val = await pending;
                        state.userIsAdmin = val;
                        return val;
                    }
                }

                const reqPromise = (async () => {
                    const res = await checkUserIsAdmin({teamId});
                    if (res?.code !== 200) {
                        return state.userIsAdmin;
                    }
                    const val = res.result;
                    if (typeof val === 'number') {
                        writeCachedAdmin(userId, teamId, val);
                        state.userIsAdmin = val;
                        return val;
                    }
                    return state.userIsAdmin;
                })();

                if (!isUpdate) adminPendingByTeamId.set(teamId, reqPromise);

                const val = await reqPromise;
                return val;
            } catch (error) {
                return state.userIsAdmin;
            } finally {
                const teamId = normalizeTeamId(payload?.teamId);
                if (teamId) adminPendingByTeamId.delete(teamId);
            }
        }, //  获取工位
        async getPositionByLoginList({state}) {
            const res = await getPositionByLogin();
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return;
            }
            state.mailWorkPosition = res.result
        },

        //     获取企业相关的全部数据
        async getCompanyCurrentInfoApis({state}) {
            const res = await getCompanyCurrentInfo()
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return;
            }
            state.companyInformation = res.result
        },

    },
};

export default user;
